// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-peqN5";
var _3 = "upgrade-YanJP";
var _4 = "subscribe-1-W4h";
var _5 = "header-3DSsC";
var _6 = "text-3Imr_";
var _7 = "footer-357KI";
var _8 = "icons-1_HSz";
var _9 = "icon-2GhBL";
var _a = "buttonWrapper-3jYKN";
var _b = "button-2_qUx";
export { _1 as "__esModule", _2 as "root", _3 as "upgrade", _4 as "subscribe", _5 as "header", _6 as "text", _7 as "footer", _8 as "icons", _9 as "icon", _a as "buttonWrapper", _b as "button" }
export default { "__esModule": _1, "root": _2, "upgrade": _3, "subscribe": _4, "header": _5, "text": _6, "footer": _7, "icons": _8, "icon": _9, "buttonWrapper": _a, "button": _b }
